import { DateTime } from "luxon";

export const PERIOD_FILTER_KEY = "periodStart";

function parseMonth(value: string): DateTime | null {
  const month = DateTime.fromISO(value, { zone: "utc" });
  return month.isValid ? month.startOf("month") : null;
}

export function readPeriodFilter(
  value: string | undefined,
  defaultStart: DateTime
): [DateTime | null, DateTime | null] {
  if (!value) return [defaultStart, null];
  if (!value.includes("..")) {
    const month = parseMonth(value);
    return [month, month];
  }
  const [start = "", end = ""] = value.split("..", 2);
  return [start ? parseMonth(start) : null, end ? parseMonth(end) : null];
}

function formatMonth(value: DateTime | null): string {
  return value?.isValid ? value.startOf("month").toFormat("yyyy-MM-dd") : "";
}

export function writePeriodFilter(
  start: DateTime | null,
  end: DateTime | null,
  defaultStart: DateTime
): string | null {
  const startValue = formatMonth(start);
  const endValue = formatMonth(end);
  const defaultValue = formatMonth(defaultStart);
  if ((!startValue && !endValue) || (startValue === defaultValue && !endValue)) return null;
  return `${startValue}..${endValue}`;
}
